// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".patsnap-design-popup__parent--hidden{padding-right:0!important}svg.patsnap-biz-icon{font-size:24px;margin-bottom:0;color:#505f79}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
